export default {"src":"/_next/static/media/chevron.b00d83fa.svg","height":8,"width":12};